import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { SendIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    message: ''
  });
  useEffect(() => {
    emailjs.init('egqV4EUcPHshTK0Gc');
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    emailjs.send('service_5jcb8ek', 'template_a6vexml', {
      content: formData.email
    }).then(() => {
      alert("Thank you for your message! We'll get back to you soon.");
      setFormData({
        name: '',
        email: '',
        role: '',
        message: ''
      });
    }, error => {
      console.error('Failed to send email:', error);
      alert('Failed to send message. Please try again.');
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const inputClasses = 'w-full px-4 py-3 bg-white border-4 border-m3-on-surface text-m3-on-surface-variant rounded focus:outline-none focus:border-m3-outline focus:shadow-[0_0_20px_rgba(69,48,15,0.2)] transition-all text-sm';
  const labelClasses = 'block text-sm font-bold text-m3-outline mb-2 uppercase tracking-wider';
  return <form onSubmit={handleSubmit} className="space-y-6" data-id="element-15">
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.1
    }} data-id="element-16">
        <label htmlFor="name" className={labelClasses} data-id="element-17">
          Player Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className={inputClasses} placeholder="Enter your name..." data-id="element-18" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.2
    }} data-id="element-19">
        <label htmlFor="email" className={labelClasses} data-id="element-20">
          Email Address
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className={inputClasses} placeholder="your.email@example.com" data-id="element-21" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.3
    }} data-id="element-22">
        <label htmlFor="role" className={labelClasses} data-id="element-23">
          Select Character
        </label>
        <select id="role" name="role" value={formData.role} onChange={handleChange} required className={inputClasses} data-id="element-24">
          <option value="" data-id="element-25">Choose your role...</option>
          <option value="parent" data-id="element-26">Parent</option>
          <option value="teacher" data-id="element-27">Teacher</option>
          <option value="tutor" data-id="element-28">Tutor</option>
          <option value="other" data-id="element-29">Other</option>
        </select>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.4
    }} data-id="element-30">
        <label htmlFor="message" className={labelClasses} data-id="element-31">
          Your Message
        </label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className={`${inputClasses} resize-none`} placeholder="Tell us how we can help..." data-id="element-32" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} data-id="element-33">
        <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-34">
          <SendIcon className="w-5 h-5" data-id="element-35" />
          Send Message
        </Button>
      </motion.div>
    </form>;
}